import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboClienteActivo`, method: 'GET', body: null, token: token})
}